module.exports = __webpack_public_path__ + "static/media/info.13b3592d.svg";